<app-applications [pageTitle]="'MENU_ATA' | translate" [serviceType]="serviceName.ATA_CARNET"></app-applications>
